import Layout from "components/layout";
import { graphql } from "gatsby";
import React from "react";
import Helmet from "react-helmet";
import AboutPersonal from "sections/about/AboutPersonal";
import HeroPersonal from "sections/hero/HeroPersonal";
import PortfolioOne from "sections/portfolio/PortfolioOne";
import ServicesThree from "sections/services/ServicesThree";
// import PortfolioTwo from "sections/portfolio/PortfolioTwo.js";
// import PortfolioThree from "sections/portfolio/PortfolioThree.js";
// import TestimonialsThree from 'sections/testimonials/TestimonialsThree.js';
// import ClientsThree from 'sections/clients/ClientsThree.js';
import ContactPersonal from "sections/contact/ContactPersonal";
// import ParticlesContainer from '../components/particles/ParticlesContainer';
// import IconsAnimation from '../components/iconsAnimation/iconsAnimation';
// import {
//   isBrowser,
//   isMobile,
//   isChrome,
//   isIE,
//   isEdge,
// } from 'react-device-detect';
import ScrollBar from "../components/scroll-bar/scroll-bar";
// import { isBrowser } from "react-device-detect";
class ClientOnlyScrollBar extends React.Component {
  state = {
    mounted: false,
  };

  componentDidMount() {
    this.setState({ mounted: true });
  }

  render() {
    if (!this.state.mounted) return null;
    if (typeof window !== "undefined" && window.innerWidth > 1000) {
      return <ScrollBar />;
    }
    return null;
  }
}

class Index extends React.Component {
  render() {
    const { site } = this.props.data;

    return (
      <div>
        <Helmet>
          <title>{site.meta.title}</title>
          <meta name="description" content={site.meta.description} />
          <meta name="keywords" content={site.meta.keywords} />
        </Helmet>
        <Layout
          isHome={true}
          sections={["home", "about", "services", "portfolio", "contact"]}
        >
          <ClientOnlyScrollBar />
          {/* <Layout
          isHome={true}
          sections={['home', 'about', 'services', 'portfolio', 'testimonials', 'clients', 'contact']}
        > */}
          <HeroPersonal />
          <AboutPersonal />
          <ServicesThree />
          <PortfolioOne />
          {/* <PortfolioTwo />
          <PortfolioThree /> */}
          {/* <TestimonialsThree /> */}
          {/* <ClientsThree /> */}
          <ContactPersonal />
        </Layout>
        {/* <ParticlesContainer /> */}
      </div>
    );
  }
}

export default Index;

export const personalQuery = graphql`
  query {
    site {
      meta: siteMetadata {
        title
        description
        keywords
      }
    }
  }
`;
